import React from "react";
import { useTenant } from "@/hooks";
import { PublicRoutes } from "./public/public.routes";
import { TenantRoutes } from "./tenant/tenant.routes";

/**
 * Selects route tree based on tenant resolution
 */
export const AppRoutes: React.FC = () => {
  const { isTenantSite } = useTenant();

  return isTenantSite ? <TenantRoutes /> : <PublicRoutes />;
};
